import { DirectSignupFiltersFormType } from 'domains/signupDirect/schemas/filtersSchema';

/**
 * Determines if private pay is offered based on the payment method and network status of the insurance.
 * @param paymentMethod The payment method to check.
 * @returns true if private pay is offered, false otherwise.
 */
export const shouldOfferPrivatePay = (paymentMethod: DirectSignupFiltersFormType['paymentMethod']) => {
  const isOtherInsurance = paymentMethod.type === 'otherInsurance';

  const isNetworkStatusOther =
    paymentMethod.type === 'insurance' && paymentMethod.insuranceData.networkStatus === 'Other';

  return isNetworkStatusOther || isOtherInsurance;
};
